import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import _isEqual from 'lodash.isequal';
import _get from 'lodash.get';
import Icon from '../../Icon';
import { INPUT } from '../../../common/styles/Input';
import LabelWrapper from '../../LabelWrapper';
import DATE_PICKER_CONTAINER from '../styles/datePickerContainer';
import 'flatpickr/dist/themes/airbnb.css';
import '../styles/_date-picker.scss';






























function ensureDateFormat(format, date) {
  if (!date) {return null;}

  return moment(date).format(format);
}

function runPickerAction(id, action) {
  const picker = document.getElementById(id);

  if (!picker || !picker._flatpickr) {return;}

  picker._flatpickr[action]();
}

export default class DatePicker extends Component {
  clearDatePicker = _memoize((pickerId) => () => {
    runPickerAction(pickerId, 'clear');
  });

  openDatePicker = _memoize((pickerId) => () => {
    runPickerAction(pickerId, 'open');
  });

  // minDate excludes the date given Eg. for 2015 Jan 1st to be the earliest date, we need to set 2014 Dec
  static defaultProps = {
    enablePastDays: false,
    displayDateFormat: 'DD/MM/YYYY',
    disableCalendar: false
  };

  onChange = _memoize((handler) => (date) => {
    handler(date[0] ? moment(date[0]) : null);
  });

  constructor(props) {
    super(props);

    this.state = {
      startFocused: false,
      endFocused: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !_isEqual(this.props, nextProps) || !_isEqual(this.state, nextState);
  }

  // Stops calendar mousedown events from reaching document-level listeners
  // that treat the calendar as "outside" — flatpickr appends the calendar
  // to <body> by default, so a parent Menu/dropdown sees clicks on month
  // nav arrows, year selector, etc. as outside-clicks and closes itself.
  stopMouseDownPropagation = (e) => {
    e.stopPropagation();
  };

  attachCalendarMouseDownGuard = (_dates, _dateStr, instance) => {
    instance.calendarContainer?.addEventListener('mousedown', this.stopMouseDownPropagation);
  };

  detachCalendarMouseDownGuard = (_dates, _dateStr, instance) => {
    instance.calendarContainer?.removeEventListener('mousedown', this.stopMouseDownPropagation);
  };

  getPickerForId = (pickerId) => {
    const picker = document.getElementById(pickerId);

    return _get(picker, '_flatpicker', {});
  };

  onFocus = (type) => () => {
    this.setState({ [type]: true });
  };

  onBlur = (type) => () => {
    this.setState({ [type]: false });
  };

  isEndDateOutsideRange = (date) => {
    const { enablePastDays, startDate, endDate } = this.props;

    if (endDate && moment(endDate).isSame(moment(date), 'day')) {
      return false;
    }

    const isEndDateBeforeStartDate = startDate && moment(date).isBefore(startDate);

    if (isEndDateBeforeStartDate) {return true;}

    const isPastDay = moment(date).diff(moment(), 'days') < 0;

    return !enablePastDays && isPastDay;
  };

  isStartDateOutsideRange = (date) => {
    const { enablePastDays, endDate, startDate } = this.props;

    if (startDate && moment(startDate).isSame(moment(date), 'day')) {
      return false;
    }

    const isStartDateAfterEndDate = endDate && moment(date).isAfter(endDate);

    if (isStartDateAfterEndDate) {return true;}

    const isPastDay = moment(date).diff(moment(), 'days') < 0;

    return !enablePastDays && isPastDay;
  };

  renderEndDatePicker() {
    const {
      onSelectEndDate,
      endDate,
      id,
      endLabel,
      endPlaceholder,
      disableCalendar,
      disabled,
      maxDate
    } = this.props;

    if (!onSelectEndDate) {return null;}

    return this.renderDatePicker({
      date: endDate,
      onDateChange: this.onChange(onSelectEndDate),
      onFocus: this.onFocus('endFocused'),
      onBlur: this.onBlur('endFocused'),
      id: `${id}-end`,
      placeholder: endPlaceholder || 'Select end date',
      label: endLabel,
      disabledDates: [this.isEndDateOutsideRange],
      disableCalendar,
      disabled,
      maxDate
    });
  }

  renderStartDatePicker() {
    const {
      onSelectStartDate,
      startDate,
      id,
      startLabel,
      startPlaceholder,
      minDate,
      disableCalendar,
      disabled,
      startDateDisabled,
      maxDate
    } = this.props;

    return this.renderDatePicker({
      date: startDate,
      onDateChange: this.onChange(onSelectStartDate),
      onFocus: this.onFocus('startFocused'),
      onBlur: this.onBlur('startFocused'),
      id: `${id}-start`,
      placeholder: startPlaceholder || 'Select start date',
      label: startLabel,
      disabledDates: [this.isStartDateOutsideRange],
      minDate,
      maxDate,
      disableCalendar,
      disabled: disabled || startDateDisabled
    });
  }

  renderDatePicker = ({
    date,
    onDateChange,
    onFocus,
    onBlur,
    id,
    placeholder,
    disabledDates,
    label,
    minDate,
    maxDate,
    disableCalendar,
    disabled













  }) => {
    const { enableTime, displayDateFormat, openDown, labelProps } = this.props;
    const dateValue = ensureDateFormat(displayDateFormat, date);
    const pickerId = `${id}-flatpicker`;

    return (
      <LabelWrapper {...labelProps} id={id} label={label}>
        <Flatpickr
          id={pickerId}
          className="flatpickr date-picker"
          value={dateValue}
          onChange={onDateChange}
          options={{
            openDirection: openDown ? 'below' : 'above',
            formatDate: (dateObject) => moment(dateObject).format(displayDateFormat),
            parseDate: (dateObject) => moment(dateObject, displayDateFormat, true).toDate(),
            disable: disabledDates,
            disabled,
            enableTime,
            wrap: true,
            dateFormat: displayDateFormat,
            minDate,
            maxDate,
            onOpen: this.attachCalendarMouseDownGuard,
            onClose: this.detachCalendarMouseDownGuard,
            onDestroy: this.detachCalendarMouseDownGuard
          }}>

          <div className="date-picker__block">
            <input
              className={INPUT({ valid: true, disabled, type: 'PRIMARY' })}
              type="text"
              placeholder={placeholder}
              disabled={disabled}
              onFocus={onFocus}
              onBlur={onBlur}
              data-input />

            {date ?
            <Icon
              className="date-picker__clear"
              onClick={this.clearDatePicker(pickerId)}
              name="close"
              size={10}
              color="regent"
              hoverColor="denim"
              disabled={disabled} /> :


            <div className="date-picker__toggle">
                <Icon
                name="bookings"
                size={20}
                color="regent"
                hoverColor="denim"
                onClick={this.openDatePicker(pickerId)}
                disabled={disableCalendar || disabled} />

              </div>}

          </div>
        </Flatpickr>
      </LabelWrapper>);

  };

  render() {
    return (
      <div className={DATE_PICKER_CONTAINER}>
        {this.renderStartDatePicker()}
        {this.renderEndDatePicker()}
      </div>);

  }
}